import './create-bespoke-rfq-email.scss'

import { notification } from 'antd'
import axios from 'axios'
import { Formik, FormikHelpers } from 'formik'
import { Form, FormItem, Input, Select, SubmitButton } from 'formik-antd'
import React from 'react'
import { Column } from 'react-display-flex'

import { filterProps, parseApiValidationErrors } from '../../../../components/forms/utils'
import { getInstrumentCodes } from '../../../../models'
import { Tenant } from '../../../Tenants/models'
import { messages } from '../../messages'
import { Issuer, rfqEmailFormInitialValues, RfqEmailFormValues } from '../../models'
import { createRfqEmailValidationSchema } from './validation'

interface CreateBespokeRfqEmailProps {
  issuers: Issuer[]
  tenants: Tenant[]
  onSuccess: () => void
}

export const CreateBespokeRfqEmail = ({ issuers, tenants, onSuccess }: CreateBespokeRfqEmailProps) => {
  const onSubmit = async (
    rfqEmailFormValues: RfqEmailFormValues,
    { setSubmitting, resetForm, setErrors }: FormikHelpers<RfqEmailFormValues>,
  ) => {
    const rfqEmailPayload = convertFormValuesToRfqEmailRequestPayload(rfqEmailFormValues)

    try {
      await axios.put('/rfqs/emails', rfqEmailPayload)

      resetForm()
      notification.success({ message: messages.common.success, description: messages.createRfqEmail.success })
      onSuccess()
    } catch (error) {
      setErrors(parseApiValidationErrors(error))
      setSubmitting(false)
      notification.error({ message: messages.common.error, description: messages.createRfqEmail.error })
    }
  }

  const instrumentCodes = getInstrumentCodes()

  return (
    <Formik
      initialValues={rfqEmailFormInitialValues}
      validationSchema={createRfqEmailValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form name="create-bespoke-rfq-email">
        <FormItem name="issuerId" label="Issuer Name" required>
          <Select
            name="issuerId"
            placeholder="Select the issuer"
            showSearch
            loading={!issuers.length}
            options={issuers?.map(({ id, shortName }) => ({ label: `${shortName} (${id})`, value: id }))}
            {...filterProps}
          />
        </FormItem>
        <FormItem name="tenantId" label="Tenant Name">
          <Select
            name="tenantId"
            placeholder="Any tenant"
            allowClear
            showSearch
            loading={!tenants.length}
            options={tenants?.map(({ id, name }) => ({ label: `${name} (${id})`, value: id }))}
            {...filterProps}
          />
        </FormItem>
        <FormItem name="instrumentCode" label="Instrument">
          <Select
            name="instrumentCode"
            placeholder="Any instrument"
            allowClear
            showSearch
            options={instrumentCodes.map((instrumentCode) => ({ label: `${instrumentCode}`, value: instrumentCode }))}
            {...filterProps}
          />
        </FormItem>
        <FormItem name="name" label="Name" required>
          <Input name="name" placeholder="Name" />
        </FormItem>
        <FormItem name="email" label="Emails" required>
          <Select name="email" placeholder="RFQ Emails" mode="tags" allowClear />
        </FormItem>
        <Column>
          <SubmitButton htmlType="submit" type="primary">
            Create RFQ Email
          </SubmitButton>
        </Column>
      </Form>
    </Formik>
  )
}

const convertFormValuesToRfqEmailRequestPayload = (values: RfqEmailFormValues) => ({
  ...values,
  instrumentCode: values.instrumentCode || undefined,
  email: values.email.join(','),
})
